var map = {
	"./img/basic-math.png": 2181,
	"./img/pi.png": 5873,
	"./img/trofeu-bronze.png": 7305,
	"./img/trofeu-silver.png": 1790,
	"./img/trofeu.png": 9374
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7528;